import {UseMutationResult, useQuery, UseQueryResult} from '@tanstack/react-query';
import {useCallback, useState} from 'react';
import {fundRepresentativesApi} from '../api';
import {CreateFundRepresentativeDTO, FundRepresentativesFilter, FundRepresentativeWithMetaModel} from '../model';
import {useCreateFundRepresentative} from './useCreateFundRepresentative';

type FundRepresentativesState = {
  getFundRepresentatives: UseQueryResult<FundRepresentativeWithMetaModel, Error>;
  filters: FundRepresentativesFilter;
  updateFilter: (newFilter: Partial<FundRepresentativesFilter>) => void;
  createMutation: UseMutationResult<unknown, Error, CreateFundRepresentativeDTO>;
};

export const useFundRepresentatives = (
  initialFilter: FundRepresentativesFilter = {},
): FundRepresentativesState => {
  const [filters, setFilters] = useState<FundRepresentativesFilter>({
    page: 1,
    pageSize: 50,
    ...initialFilter,
  });

  const getFundRepresentatives = useQuery<FundRepresentativeWithMetaModel, Error>({
    queryKey: ['fund-representatives', filters],
    queryFn: () => fundRepresentativesApi.getFundRepresentatives(filters),
  });

  const updateFilter = useCallback((newFilter: Partial<FundRepresentativesFilter>) => {
    setFilters((prev) => ({
      ...prev,
      ...newFilter,
      ...(!newFilter.page && !newFilter.pageSize ? {page: 1} : {}),
    }));
  }, []);

  const createMutation = useCreateFundRepresentative();

  return {
    getFundRepresentatives,
    filters,
    updateFilter,
    createMutation,
  };
};
